class ScrollShadow {
	target = null;
	shadow = null;
	lastPageReached = false;
	raf = null;

	constructor(target, isInfiniteScroll) {
		this.target = target;
		if (!isInfiniteScroll) this.lastPageReached = true;
		this.init();
	}

	init() {
		this.target.addEventListener('scroll', this.handleScroll);
		window.addEventListener('resize', this.handleWindowResize);

		this.update();
	}

	destroy() {
		this.target.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('resize', this.handleWindowResize);
		this.destroyShadow();
	}

	get isScrollable() {
		return this.target.scrollHeight !== this.target.clientHeight;
	}

	get isAtScrollEnd() {
		const { clientHeight, scrollHeight, scrollTop } = this.target;
		const detectionOffset = 1;
		return scrollHeight <= Math.round(scrollTop + clientHeight) + detectionOffset;
	}

	get isHidden() {
		const { clientHeight, scrollHeight } = this.target;
		return clientHeight === 0 && scrollHeight === 0;
	}

	createShadow() {
		const shadow = document.createElement('div');
		Object.assign(shadow.style, {
			position:      'absolute',
			width:         '100%',
			height:        '100%',
			top:           0,
			left:          0,
			pointerEvents: 'none',
		});
		const inner = document.createElement('div');
		Object.assign(inner.style, {
			position:   'absolute',
			width:      '100%',
			height:     '80px',
			bottom:     0,
			left:       0,
			background: 'linear-gradient(360deg, var(--color-black) 0%, rgba(0, 0, 0, 0) 100%)',
		});
		shadow.append(inner);
		this.shadow = shadow;
		this.target.append(this.shadow);
	}

	setLastPageReached(value) {
		this.lastPageReached = value;
	}

	destroyShadow() {
		if (!this.shadow) return;
		this.shadow.remove();
		this.shadow = null;
	}

	handleWindowResize = () => {
		this.update();
	};

	handleScroll = () => {
		this.update();
	};

	update() {
		cancelAnimationFrame(this.raf);
		this.raf = requestAnimationFrame(() => {
			// Create shadow if it's scrollable or if it's hidden because otherwise it doesn't init properly
			if ((this.isScrollable && !this.isAtScrollEnd) || (this.isHidden && !this.lastPageReached)) {
				if (!this.shadow) this.createShadow();
			} else if (this.shadow) {
				if (!this.lastPageReached) return;
				this.destroyShadow();
			}
		});
	}
}

const scrollShadowMixin = {
	data() {
		return { shadowWatchers: [] };
	},
	methods: {
		registerShadowWatcher(parent, isInfiniteScroll) {
			if (!parent) return null;
			const scrollShadow = new ScrollShadow(parent, isInfiniteScroll);
			this.shadowWatchers.push(scrollShadow);
			return scrollShadow;
		},
		updateShadowWatchers() {
			for (const shadowWatcher of this.shadowWatchers) {
				shadowWatcher.update();
			}
		},
	},
	destroyed() {
		for (const shadowWatcher of this.shadowWatchers) {
			shadowWatcher.destroy();
		}
	},
};

export default scrollShadowMixin;
